import {
    LayerType,
    type BaseTextInfo,
    type ILayerProps,
    type ITextLayerProps,
    type IVectorLayerProps,
} from '@/version-types';

export const extractBaseTextInfoFromTextLayer = (layer: ILayerProps) => {
    const { layerType } = layer;
    if (layerType !== LayerType.TEXT_LAYER) {
        throw new Error('layerType should be TEXT_LAYER');
    }

    const layerData = layer.data as ITextLayerProps;

    const runtime = layer.__runtime || {};
    const fontFamilyMap = runtime.fontFamilyMap || {};

    const fontFamily = fontFamilyMap[layerData.fontFamily] || layerData.fontFamily;

    const ret: BaseTextInfo = {
        text: layerData.text,
        color: layerData.color,
        fontSize: layerData.fontSize,
        fontFamily,
        lineSpacing: layerData.lineSpacing,
        letterSpacing: layerData.letterSpacing,
        bold: layerData.bold,
        italic: layerData.italic,
        lineThrough: layerData.lineThrough,
        underline: layerData.underline,
        textAlign: layerData.textAlign,
        verticalAlign: layerData.verticalAlign,
        writingMode: layerData.writingMode,
        opacity: layer.opacity,
    };

    const { listStyle = '', listStyleMaterial, textContents = [] } = layerData;

    if (listStyle) ret.listStyle = listStyle;
    if (listStyleMaterial) ret.listStyleMaterial = listStyleMaterial;

    if (textContents.length > 0) {
        ret.textContents = textContents.map((item) => ({
            ...item,
            fontFamily: fontFamilyMap[item.fontFamily] || item.fontFamily,
        }));
    }

    return ret;
};

export const extractBaseTextInfoFromVectorLayer = (layer: ILayerProps) => {
    const { layerType } = layer;
    if (layerType !== LayerType.VECTOR_LAYER) {
        throw new Error('layerType should be VECTOR_LAYER');
    }

    const layerData = layer.data as IVectorLayerProps;
    const { textInfo } = layerData;

    if (!textInfo) {
        throw new Error('Can not find `textInfo` in VectorLayer');
    }

    const runtime = layer.__runtime || {};
    const fontFamilyMap = runtime.fontFamilyMap || {};

    const fontFamily = fontFamilyMap[textInfo.fontFamily] || textInfo.fontFamily;

    const ret: BaseTextInfo = {
        text: textInfo.text,
        color: textInfo.color,
        fontSize: textInfo.fontSize,
        fontFamily,
        lineSpacing: textInfo.lineSpacing,
        letterSpacing: textInfo.letterSpacing,
        bold: textInfo.bold,
        italic: textInfo.italic,
        lineThrough: textInfo.lineThrough,
        underline: textInfo.underline,
        textAlign: textInfo.textAlign,
        writingMode: textInfo.writingMode,
        opacity: textInfo.opacity,
        verticalAlign: textInfo.verticalAlign,
    };

    const { listStyle = '' } = textInfo;

    if (listStyle) ret.listStyle = listStyle;

    return ret;
};
